import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TipEffects } from '@appStore/app/effects/tip.effects';

export const effects: any[] = [
  TipEffects
];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class AppEffectsModule {}